<template>
	<div class="wrap">
		<div class="title">
			<div class="title_left">
				投诉反馈
				<!--<span class="divide" v-if="subordinate">/</span>-->
				<!--<span v-if="subordinate" :class="infoName?'movePoin':'colorG'" @click="goBack">{{subordinate}}</span>-->
				<!--<span class="divide" v-if="infoName">/</span>-->
				<!--<span v-if="infoName" class="colorG">{{infoName}}</span>-->
			</div>
		</div>
		<div v-if="false" class="innerBox">
			<ErrorTemplate></ErrorTemplate>
		</div>
		<div v-if="true">
			<Table v-if="!infoName" :activeIndex="activeIndex" :subordinate="subordinate" @titChange="titChange"
				@infoTitChange="infoTitChange"></Table>
			<Info v-if="infoBoxShow" :recordId="recordId"></Info>
			<FeedbackInfo v-if="feedbackState" :InfoType="feedbackState" @goBack="goBack" :feedback="feedback"
				:recordId="recordId" class="mt20 mb60"></FeedbackInfo>
			<div class="footDiv" v-if="infoName">
				<button class="mr20" @click=goBack>返 回</button>
				<button class="mr20">删 除</button>
				<button class="fk" v-if="infoName=='查看详情'&& feedbackState==''"
					@click="infoTitChange(recordId,'反馈',true,'add')">反 馈</button>
				<button class="fk" v-if="infoName=='查看详情'&& feedbackState=='info'"
					@click="infoTitChange(recordId,'重新反馈',true,'edit')">重新反馈</button>
				<button class="fk" v-if="infoName=='反馈' || infoName=='重新反馈'" @click="feedbackGo">确 定</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Table from './table.vue'
	import Info from './info.vue'
	import FeedbackInfo from './feedbackInfo.vue'
	export default {
		components: {
			Table,
			Info,
			FeedbackInfo
		},
		data() {
			return {
				activeIndex: '待反馈',
				subordinate: '待反馈',
				infoName: '',
				infoBoxShow: false,
				feedbackState: '',
				recordId: '',
				feedback: 0
			}
		},
		mounted() {},
		methods: {
			titChange(name) {
				this.subordinate = name;
			},
			infoTitChange(id, name, infoBox, feedbackBox) {
				this.infoName = name;
				this.infoBoxShow = infoBox;
				this.recordId = id;
				this.feedbackState = feedbackBox || '';
			},
			goBack() {
				this.infoName = '';
				this.activeIndex = this.subordinate;
				this.infoBoxShow = false;
				this.feedbackState = '';
			},
			feedbackGo() {
				this.feedback = this.feedback + 1
			}
		},
	}
</script>

<style scoped lang="scss">
	.wrap {
		width: calc(100% - 40px);
		padding: 0 20px;
		height: 100%;
		background: #f6f6f6;

		.title {
			height: 60px;
			line-height: 60px;

			.title_left {
				font-size: 20px;
				font-weight: 400;
				color: rgba(51, 51, 51, 1);
				width: 50%;
				height: 100%;

				.divide {
					margin: 0 5px;
				}
			}
		}

		.footDiv {
			background: #fff;
			position: fixed;
			bottom: 0;
			padding: 10px 20px;
			width: calc(100% - 280px);
			margin-left: -20px;
			text-align: right;

			button {
				border-radius: 4px;
				border: 1px solid rgba(221, 221, 221, 1);
				width: 70px;
				height: 32px;
				font-size: 14px;
				color: #666666;
				background: #fff;
			}

			.fk {
				color: #fff;
				background: #70CE97;
				border: none;
			}
		}
	}

	.colorG {
		color: #70CE97;
	}

	.mb60 {
		margin-bottom: 60px;
	}

	.innerBox {
		width: calc(100% - 60px);
		padding: 20px 30px;
		height: calc(100% - 125px);
		background: #fff;
		border-radius: 10px;
	}
</style>